let $growlMessage = $('div[data-growls-id]');
if ($growlMessage.length !== 0) {
    $growlMessage.each(function() {
        let $message = $(this);
        jQuery.growl({
            title: $message.text(),
            message: '',
            size: 'small',
            location: $message.data('growls-id'),
            style: 'default',
            duration: 10000
        });
    });
}
